import { EditCompanyPanelBaseDataProvider } from './EditCompanyPanelBaseDataProvider';
import { CompanyData } from '../../../types/company-data';

export class EditCompanyPanelGzDataProvider extends EditCompanyPanelBaseDataProvider {
  public async getManagedCompanyById(companyId: string): Promise<CompanyData> {
    const record = await this.dependencies.api.clients.Company.GetManagedCompanyById(companyId).toPromise();

    if (!record) {
      throw new Error('No edited company data');
    }

    return record;
  }
}
